export default function getTextEditorValueLength(values): number {
  return values?.replace(/<\/?[^>]+(>|$)/g, "")?.length || values?.length || 0;
}
